/// <reference types="@angular/localize" />

import {
  enableProdMode,
  ErrorHandler,
  importProvidersFrom,
} from "@angular/core";
import { registerLocaleData } from "@angular/common";
import { environment } from "./environments/environment";
import { GlobalErrorHandler } from "./app/global-error-handler";
import {
  provideHttpClient,
  withInterceptors,
} from "@angular/common/http";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { BrowserModule, bootstrapApplication } from "@angular/platform-browser";
import { provideAnimations } from "@angular/platform-browser/animations";
import { withRouterConfig, provideRouter } from "@angular/router";
import { ROUTES } from "./app/app.routes";
import { ToastrModule } from "ngx-toastr";
import { ClipboardModule } from "ngx-clipboard";
import { NgIdleKeepaliveModule } from "@ng-idle/keepalive";
import { AppComponent } from "./app/app.component";
import { ServiceLocator } from "./app/core/services/service.locator";
import localeSL from "@angular/common/locales/sl";
import localeSlExtra from "@angular/common/locales/extra/sl";
import { httpConfigInterceptor } from "./app/core/interceptors/http-authorization.interceptor";
import { withCredentialsInterceptor } from "./app/core/interceptors/http-with-credentials-authorization";
import { provideApiConfiguration } from "./app/data/api/api-configuration";
import { customProvideApiConfiguration } from "./app/core/services/custom-provide-api-configuration";

registerLocaleData(localeSL, "sl", localeSlExtra);

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
  providers: [
    importProvidersFrom(
      FormsModule,
      ReactiveFormsModule,
      BrowserModule,
      ToastrModule.forRoot({ preventDuplicates: true }),
      ClipboardModule,
      NgIdleKeepaliveModule.forRoot()
    ),
    { provide: ErrorHandler, useClass: GlobalErrorHandler },
    provideHttpClient(
      withInterceptors([withCredentialsInterceptor, httpConfigInterceptor])
    ),
    provideAnimations(),
    provideRouter(ROUTES, withRouterConfig({ onSameUrlNavigation: "reload" })),
    provideApiConfiguration("/api"),
    customProvideApiConfiguration("/api"),
  ],
})
  .then((appRef) => {
    // Setup ServiceLocator
    ServiceLocator.injector = appRef.injector;
  })
  .catch((err) => console.error(err));
